import { useState } from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { IPOSMaterialCode, IPOSMaterialCodeInput, type VatTu } from '@/types/schemas';
import { formSchema, FormValues, initialValues } from '../schemas';
import { FormMode } from '@/types/form';
import BasicInfo from './BasicInfo';

interface FormDialogProps {
  mode: FormMode;
  open: boolean;
  onClose: () => void;
  onSubmit: (data: IPOSMaterialCodeInput) => void;

  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
  onWatchButtonClick?: () => void;

  initialData?: IPOSMaterialCode | null;
}

function FormDialog({
  mode,
  open,
  onClose,
  onSubmit,
  onAddButtonClick,
  onCopyButtonClick,
  onDeleteButtonClick,
  onEditButtonClick,
  initialData
}: FormDialogProps) {
  const [material, setMaterial] = useState<VatTu | null>(initialData?.ma_vt_data || null);
  const handleSubmit = (data: FormValues) => {
    onSubmit({
      ...data,
      ma_khai_bao: data.ma_khai_bao as string,
      ma_vt: material?.uuid || ''
    });
  };
  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem'}
        maxWidth='lg'
        disableBackdropClose={false}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2
          mode={mode}
          hasAritoActionBar={false}
          schema={formSchema}
          onSubmit={handleSubmit}
          initialData={(initialData || initialValues) as FormValues}
          className='min-w-[600px]'
          headerFields={<BasicInfo mode={mode} material={material} setMaterial={setMaterial} />}
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onSubmit={() => {}}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
}

export default FormDialog;
